import { ProductionData } from '../../../../models/analysis/solar-calculator-request';
import * as dayjs from 'dayjs';

export abstract class ParseProduction {
  private dataColumn: number;
  private startingRowIndex: number;
  private productionSum = 0;
  private peakPower: number[] = [];
  private peakPowerSum: number = 0;
  private currentHour: number = -1;
  parseChunk(csvData: string[][]): ProductionData[] {
    if (!this.dataColumn) {
      this.dataColumn = this.findColumnsProduction(csvData);
    }

    if (!this.startingRowIndex) {
      this.startingRowIndex = this.findRowProduction(csvData);
      if (this.startingRowIndex === -1) {
        return [];
      }
      csvData = csvData.slice(this.startingRowIndex);
    }

    const productionData: ProductionData[] = [];
    for (const row of csvData) {
      if((row.length === 1)) {
        continue;
      }
      const date = dayjs(row[0], this.dateFormat);
      const productionValue = +(row[this.dataColumn].replaceAll(',', '.'));
      if (date.hour() !== this.currentHour) {
        this.peakPower.push(this.peakPowerSum);
        productionData.push({
          production: this.productionSum.toString(),
          peakPower: this.peakPower.map(number => (number * this.peakPower.length).toString()),
        });
        this.currentHour = date.hour();
        this.productionSum = productionValue;
        this.peakPower = [];
        this.peakPowerSum = productionValue;
      } else {
        if (date.minute() % 15 === 0) {
          this.peakPower.push(this.peakPowerSum);
          this.peakPowerSum = 0;
        } else {
          this.peakPowerSum += productionValue;
        }
        this.productionSum += productionValue;
      }
    }
    return productionData;
  }

  public getFinalData() {
    this.peakPower.push(this.peakPowerSum);
    return {
      production: this.productionSum.toString(),
      powerPeak: this.peakPower.length > 1 ? this.peakPower.map(number => (number * this.peakPower.length).toString()) : null,
    };
  }

  abstract get dateFormat();

  abstract findColumnsProduction(csvData: string[][]): number;

  abstract findRowProduction(csvData: string[][]): number;
}
